export default "__VITE_ASSET__CvrWvFOj__"